import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, LoadingController, AlertController, IonInput } from '@ionic/angular';
import { CartService } from '../../services/cart.service';
import { PersonService } from '../../services/person.service';
import { OrganisationService } from '../../services/organisation.service';
import { Decimal } from 'decimal.js';

@Component({
    selector: 'app-checkout-payment-store-credit',
    templateUrl: './checkout-payment-store-credit.page.html',
    styleUrls: ['./checkout-payment-store-credit.page.scss'],
})
export class CheckoutPaymentStoreCreditPage implements OnInit {

    @ViewChild('payment_amount_input', { static: false }) payment_amount_input: IonInput;

    store_credit = null;
    cart = null;
    payment_amount = null;

    payment = {
        method: null,
        price: null,
        label:'Store credit'
    };

    selectOptions: any = {
        cssClass: 'wide-select'
    };

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private cartService: CartService,
        private personService: PersonService,
        private organisationService: OrganisationService
    ) { }

    ngOnInit() {

        this.cartService.get().then((cart) => {
            if (cart) {
                this.cart = cart;
                if(this.cart.organisation) {
                    this.payment.method = 'organisation_store_credit';
                    this.organisationService.getOrganisationStoreCredit(this.cart.organisation.id, this.cart.currency.id).then((store_credit: any) => {
                        if(store_credit) {
                            this.store_credit = store_credit;
                        }
                    })
                    .catch(() => { });
                }
                else {
                    this.payment.method = 'person_store_credit';
                    this.personService.getPersonStoreCredit(this.cart.person.id, this.cart.currency.id).then((store_credit: any) => {
                        if(store_credit) {
                            this.store_credit = store_credit;
                        }
                    })
                    .catch(() => { });
                }
            }
        });
       
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.payment_amount_input) {
                this.payment_amount_input.setFocus();
            }
        }, 200);
    }

    close() {
        this.modalController.dismiss();
    }

    sanitisePaymentAmount() {

        let payment_amount = this.payment_amount.toString();
        
        // only accept numbers/decimal points
        if(/[^0-9.]/.test(payment_amount)) {
            this.payment.price = null;
        }        
        else if(payment_amount.startsWith('.')) {
            this.payment.price = null;
        }
        else if(payment_amount.endsWith('.')) {
            this.payment.price = null;
        }              
        else if(payment_amount.split('.').length > 2) {
            this.payment.price = null;
        }
        else if(!payment_amount.length) {
            this.payment.price = null;
        }
        else {
            this.payment.price = Number(new Decimal(payment_amount).toDecimalPlaces(2));
        }

    }

    addPayment() {

        // ensure payment isn't over the amount due
        if(this.payment.price > this.cart.amount_due) {
            this.payment.price = this.cart.amount_due;
        }
        
        let allow_add_payment = true;

        if(this.payment.price > this.store_credit.balance) {
            allow_add_payment = false;
        }

        if(allow_add_payment) {
            this.cartService.addPayment(this.payment).then(() => {
                this.modalController.dismiss();
            });
        }
        else {
            this.presentAlert("Problem", "The store credit doesn\'t have enough balance.", "");
        }

    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }


}
